// extracted by mini-css-extract-plugin
export default {"root":"ImportEmployeesReportStats_root__j5rA6","title":"ImportEmployeesReportStats_title__jiy9-","value":"ImportEmployeesReportStats_value__mh0cN"};